import { render, staticRenderFns } from "./ProviderExternMailingConf.vue?vue&type=template&id=e720f71c&"
import script from "./ProviderExternMailingConf.vue?vue&type=script&lang=js&"
export * from "./ProviderExternMailingConf.vue?vue&type=script&lang=js&"
import style0 from "./ProviderExternMailingConf.vue?vue&type=style&index=0&id=e720f71c&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports